/**
 * matchBrowserMenuView — pure HTML/payload helpers for P6-12 match browser UI.
 */

import { ROOM_VISIBILITY } from '../../domain/net/wsProtocol.js';
import { MP_TEST_MAP_ID } from '../../domain/map/mpTestDefaults.js';

export const MATCH_BROWSER_MAP_LABELS = {
  aram_proving_grounds: 'The Proving Grounds (ARAM)',
  test_map: 'Test & Debug Sandbox',
  twisted_treeline_3v3: 'Twisted Treeline (3v3)',
  summoners_rift_5v5: "Summoner's Rift (5v5)"
};

export function buildCreateRoomPayload({ mapId, visibility, password } = {}) {
  const vis = visibility || ROOM_VISIBILITY.PUBLIC;
  if (!mapId) throw new Error('map_required');
  if (vis === ROOM_VISIBILITY.PRIVATE) {
    if (!password || !String(password).trim()) {
      throw new Error('password_required');
    }
    return {
      mapId,
      visibility: ROOM_VISIBILITY.PRIVATE,
      password: String(password).trim()
    };
  }
  return { mapId, visibility: ROOM_VISIBILITY.PUBLIC };
}

export function renderRoomListHtml(rooms = []) {
  if (!rooms.length) {
    return '<p class="mb-empty">No hay partidas públicas abiertas.</p>';
  }
  return rooms.map((r) => {
    const mapLabel = MATCH_BROWSER_MAP_LABELS[r.mapId] || r.mapId;
    const count = `${r.playerCount || 0}/${r.targetSize || '?'}`;
    const host = r.hostName || r.hostId || 'host';
    return (
      `<button type="button" class="mb-room-row" data-room-id="${r.roomId}">` +
      `<span class="mb-room-id">${r.roomId}</span>` +
      `<span class="mb-room-map">${mapLabel}</span>` +
      `<span class="mb-room-count">${count}</span>` +
      `<span class="mb-room-host">${host}</span>` +
      `</button>`
    );
  }).join('');
}

export function showPanel(panel) {
  if (!panel) return;
  panel.hidden = false;
  // Clear inline display so .mb-panel { display:flex; flex-direction:column } wins
  if (panel.style) panel.style.display = '';
}

export function hidePanel(panel) {
  if (!panel) return;
  panel.hidden = true;
  // [hidden] { display:none !important } — clear stale inline overrides
  if (panel.style) panel.style.display = '';
}

export function populateMatchBrowserMaps(mapSelect, maps) {
  if (!mapSelect) return;
  const ids = maps && maps.length ? maps : [MP_TEST_MAP_ID];
  mapSelect.innerHTML = ids.map((id) => {
    const label = MATCH_BROWSER_MAP_LABELS[id] || id;
    const sel = id === MP_TEST_MAP_ID ? ' selected' : '';
    return `<option value="${id}"${sel}>${label}</option>`;
  }).join('');
  if (!mapSelect.value) mapSelect.value = ids[0];
}
